import styled from "styled-components";
export const MiniErrors = styled.p`
  font-size: 15px;
  color: red;
  font-family: "Inter";
`;
